import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Row,
  Col,
  Card,
  CardBody,
  CardText
} from 'reactstrap';

import { CardHeaderWithToolbars,Title } from '../../components/Card/CardHeaderWithToolbars';
import {Tbl, TblHead, TblBody} from '../../components/Tbl';
import Paginations from '../../components/Paginations';
import PaginationSummaries from '../../components/Paginations/PaginationSummaries';
import FontAwesomeIcon from '../../components/Icons/FontAwesomeIcon';

import { getBidList, deleteBid } from '../../actions/bidAction';

import { generateNumber } from '../../utils';
import { DEFAULT_PER_PAGE } from '../../constants/settings';
import { DEFAULT_CATEGORY_NAME } from '../../constants/kickavenue';
import privateView from '../../components/hocs/privateView';
import RowItem from './bidIndex/RowItem';
import Toolbars from './bidIndex/Toolbars';
import FilterPanel from './bidIndex/FilterPanel';
import { getOptionList as getCategoryOptions } from '../../actions/categoriesAction';
import { Th } from '../../components/Tbl';
import Analytics from "../../services/Analytics";

const defaultParams={
  sort_by : 'createdAt_desc',
  per_page : DEFAULT_PER_PAGE
}

class BidIndex extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      _isFilterOpen: false,
      _isResetFilter: false,
      _params: {
        ...defaultParams
      }
    }
    this._handleGoto = this._handleGoto.bind(this);
    this._refreshList = this._refreshList.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    const { dataCategories } = this.props;
    if(!dataCategories.length){
      this.props.getCategoryOptions();
    } else {
      const categoryId = this._getDefaultCategoryId();
      this.setState({
        _params: { ...this.state._params, ...(categoryId ? { category_id: categoryId } : {}) }
      }, () => this._getList(this.state._params));
    }
    Analytics.recordPageView('offers_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentDidUpdate(prevProps){
    if(prevProps.dataCategories.length === 0 && this.props.dataCategories.length > 0){
      const categoryId = this._getDefaultCategoryId();
      if(categoryId && !this.state._params.category_id){
        this.setState({
          _params: { ...this.state._params, category_id: categoryId }
        }, () => this._getList(this.state._params));
      }
    }
  }

  _getDefaultCategoryId(){
    const { dataCategories } = this.props;
    const found = dataCategories.find(
      cat => cat.label.toLowerCase() === DEFAULT_CATEGORY_NAME.toLowerCase()
    );
    return found ? found.value : null;
  }

  _getList(rawParams = {}){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    this.props.getList({params});
  }
  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _handleApplyFilter(payloadFilter){
    // e.preventDefault();
    // const { sort_by, ..._params } = payloadFilter;
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
        page: 1
      },
    },()=>this._getList(this.state._params));
  }

  _refreshList(){
    const { _params } = this.state;
    this.setState({
      _params:{ ..._params, page: 1 },
    },()=>this._getList(this.state._params));
  }

  _handleResetFilter(e){
    e.preventDefault();
    const categoryId = this._getDefaultCategoryId();
    this.setState({
      _params:{
        ...defaultParams,
        ...(categoryId ? { category_id: categoryId } : {})
      },
      _isResetFilter: true
    },()=>this._getList(this.state._params));
  }

  _handleGoto(page){
    const _params = this.state._params;
    _params.page = page;
    this.setState({ _params },()=>this._getList(this.state._params));
  }

  _onRenderPagination(){
    const { status_code, data } = this.props.bidList;
    const hasData = (status_code===200 && data.length)||null;
    return hasData && (
      <Paginations
        isLoading={this.props.bidList.isFetch}
        size="sm"
        lastPage={this.props.bidList.last_page}
        perPage={this.props.bidList.per_page}
        total={this.props.bidList.total}
        maxPage={8}
        path={this.props.bidList.path}
        currentPage={this.props.bidList.current_page}
        prevPageUrl={this.props.bidList.prev_page_url}
        nextPageUrl={this.props.bidList.next_page_url}
        handleGotoCallback={this._handleGoto}
        onCurrentPageChanged={() => {
          window.scrollTo({
            top: this.tableRef.offsetTop+25,
            behavior: 'smooth'
          })
        }}
      />
    )
	}

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <FontAwesomeIcon iconType="align-justify"/>
                  <span>User Offer List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._isFilterOpen}
                  onToggleFilter={()=> this.setState({ _isFilterOpen: !this.state._isFilterOpen })}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterPanel
                {...this.state._params}
                isOpen={this.state._isFilterOpen}
                isReset={this.state._isResetFilter}
                onApplyFilter={this._handleApplyFilter}
                onResetFilterCallback={()=>this.setState({_isResetFilter: false, _isFilterOpen: false})}
              />
              <CardBody>
                <CardText>
                  In this section will display our user's offers.
                </CardText>
                <div className="table-responsive" ref={tableRef => this.tableRef = tableRef}>
                  <PaginationSummaries
                    from={this.props.bidList.from}
                    to={this.props.bidList.to}
                    total={this.props.bidList.total}
                  />
                  <Tbl>
                    <TblHead
                      renderChildren={()=>(
                        <tr>
                          <Th>No.</Th>
                          <Th>Offer</Th>
                          <Th>User</Th>
                          <Th>Payment</Th>
                          <Th>Status</Th>
                          <Th>Updated</Th>
                          <Th>Action</Th>
                        </tr>
                      )}
                    />
                    <TblBody
                      isLoad={this.props.bidList.isFetch}
                      hasRow={this.props.bidList.status_code===200&&this.props.bidList.data.length>0}
                      columnCount={7}
                      renderChildren={()=>{
                        const { current_page,per_page } =  this.props.bidList;
                        return this.props.bidList.data.map((item, index)=> {
                          const rowNumber = generateNumber(per_page,current_page,index);
                          return (
                            <RowItem
                              key={item.id}
                              id={item.id}
                              rowNumber={rowNumber}
                              category={item.product_variant.product.category&&item.product_variant.product.category.name}
                              code={item.code}
                              user={item.user}
                              seller={item.user_sell && item.user_sell.user}
                              amount={item.amount}
                              paymentMethod={item.payment_method}
                              updatedAt={item.updated_at}
                              createdAt={item.created_at}
                              expiredAt={item.expired_at}
                              deletedAt={item.deleted_at}
                              status={item.status}
                              payment={item.offer}
                              size={item.size.US}
                              displayName={item.product_variant.display_name}
                              colour={item.product_variant.colour}
                              SKU={item.product_variant.SKU}
                              onDeleteBid={(id)=>this.props.deleteBid(id)}
                            />
                          )
                        })
                      }}
                    >
                    </TblBody>
                  </Tbl>
                  { this._onRenderPagination() }
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}


const mapStateToProps = ({ bid: { list }, auth: { isFetch, isLogged, roles, id, email }, masterCategories: { options: dataCategories } }) => ({
  bidList: list,
  guardData: { isFetch, isLogged, roles, id, email },
  dataCategories
})

const mapDispatchToProps = dispatch => ({
  getList: query => dispatch(getBidList(query)),
  deleteBid: id => dispatch(deleteBid(id)),
  getCategoryOptions: () => dispatch(getCategoryOptions())
})

const enhance = connect(mapStateToProps,mapDispatchToProps);

export default enhance(privateView(BidIndex));

BidIndex.defaultProps = {

}

BidIndex.propTypes = {

}